const debounce = (callback, wait) => {
    let timeout = null;
    return (...args) => {
        const next = () => callback(...args);
        clearTimeout(timeout);
        timeout = setTimeout(next, wait)
    }
};

const objectHasValue = (obj, value) => Object.values(obj).indexOf(value) > -1

// returns array of objects with unique property specified in the second argument
const unique = (array, propertyName) => {
    const result = [];
    const map = new Map();
    for (const item of array) {
        if(!map.has(item[propertyName])){
            map.set(item[propertyName], true);    // set any value to Map
            result.push(item);
        }
    }

    return result;
}


const messageReactNative = (message) => {
    if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(message)
    }
};

export default {
    debounce,
    objectHasValue,
    unique,
    messageReactNative
}
